import { StyledLabelOffBox, StyledLabelText } from './style';

type Props = {
  isLiftStationMobile?: boolean;
};

export const StateLabelOffBox = ({ isLiftStationMobile }: Props) => (
  <StyledLabelOffBox isLiftStationMobile={isLiftStationMobile ?? false}>
    <StyledLabelText isLiftStationMobile={isLiftStationMobile ?? false}>Off</StyledLabelText>
  </StyledLabelOffBox>
);
